import React from "react";
import { isB2C, isNovium } from "../../libs/env";
import { find, includes } from "lodash";
import AssessmentWarnings from "./assessmentWarnings";

export const status = {
  inprogress: "In progress",
  completed: "Completed",
  not_started: "Not Started",
};

export const PagePagination = ({
  page_id,
  currentSectionPage,
  onClick,
  section,
  answers,
  data,
  visited_pages,
  page_number,
  section_number,
  currentStandingPage,
  pagination_color_decision,
}) => {
  let assessment_warnings = AssessmentWarnings(data,answers);

  let className =
    currentStandingPage === parseInt(`${section_number}${page_number}`)
      ? "btn-warning"
      : "btn-secondary";

  visited_pages &&
    visited_pages.forEach((visited_page) => {
      visited_page.pages &&
        visited_page.pages.forEach((page) => {
          let find_from_user_selected_answers = find(answers, [
            "exercise_id",
            page.exercise_id,
          ]);
          let find_section_from_warnings = find(assessment_warnings, [
            "section_number",
            visited_page.section_number,
          ]);

          let find_no_of_pages_from_section = undefined;
          if (find_section_from_warnings) {
            find_no_of_pages_from_section = find(
              find_section_from_warnings.pages,
              ["page_number", page.page_number]
            );
          }

          if (
            find_from_user_selected_answers &&
            currentSectionPage === page.pagination_number &&
            page.pagination_number !== currentStandingPage &&
            !find_no_of_pages_from_section
          ) {
            className = "btn-success";
            let find_section_in_pagination_color_decision = find(
              pagination_color_decision,
              ["section_number", visited_page.section_number]
            );
            if (find_section_in_pagination_color_decision) {
              let find_page_number_in_color_decision = find(
                find_section_in_pagination_color_decision.pages,
                ["page_number", page.page_number]
              );
              if (find_page_number_in_color_decision) {
                if (
                  !includes(
                    find_page_number_in_color_decision.status,
                    status.completed
                  )
                ) {
                  find_page_number_in_color_decision.status.push(
                    status.completed
                  );
                }
              } else {
                find_section_in_pagination_color_decision.pages.push({
                  page_number: page.page_number,
                  status: [status.completed],
                });
              }
            } else {
              pagination_color_decision.push({
                section_number: visited_page.section_number,
                pages: [
                  { page_number: page.page_number, status: [status.completed] },
                ],
              });
            }
          } else if (
            find_from_user_selected_answers &&
            currentSectionPage === page.pagination_number &&
            page.pagination_number !== currentStandingPage &&
            find_no_of_pages_from_section
          ) {
            className = "btn-orange";
            let find_section_in_pagination_color_decision = find(
              pagination_color_decision,
              ["section_number", visited_page.section_number]
            );
            if (find_section_in_pagination_color_decision) {
              let find_page_number_in_color_decision = find(
                find_section_in_pagination_color_decision.pages,
                ["page_number", page.page_number]
              );
              if (find_page_number_in_color_decision) {
                if (
                  !includes(
                    find_page_number_in_color_decision.status,
                    status.inprogress
                  )
                ) {
                  find_page_number_in_color_decision.status.push(
                    status.inprogress
                  );
                }
              } else {
                find_section_in_pagination_color_decision.pages.push({
                  page_number: page.page_number,
                  status: [status.inprogress],
                });
              }
            } else {
              pagination_color_decision.push({
                section_number: visited_page.section_number,
                pages: [
                  {
                    page_number: page.page_number,
                    status: [status.inprogress],
                  },
                ],
              });
            }
          } else {
            let find_section_in_pagination_color_decision = find(
              pagination_color_decision,
              ["section_number", visited_page.section_number]
            );
            if (find_section_in_pagination_color_decision) {
              let find_page_number_in_color_decision = find(
                find_section_in_pagination_color_decision.pages,
                ["page_number", page.page_number]
              );
              if (find_page_number_in_color_decision) {
                if (
                  !includes(
                    find_page_number_in_color_decision.status,
                    status.not_started
                  )
                ) {
                  find_page_number_in_color_decision.status.push(
                    status.not_started
                  );
                }
              } else {
                find_section_in_pagination_color_decision.pages.push({
                  page_number: page.page_number,
                  status: [status.not_started],
                });
              }
            } else {
              pagination_color_decision.push({
                section_number: visited_page.section_number,
                pages: [
                  {
                    page_number: page.page_number,
                    status: [status.not_started],
                  },
                ],
              });
            }
          }
        });
    });
  if(isB2C.some(domain => window.location.origin.includes(domain)) || window.location.origin.includes(isNovium))
  {
    return (
      <div className="mb-2"></div>
    );
  }
  return (
    <input
      type="button"
      className={`btn  ${className}  px-0 py-0 mt-1 me-1 btn-sm w-10`}
      value={page_id}
      onClick={() => onClick(section, currentSectionPage)}
    />
  );
};
